import {useState, useRef} from "react";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DataRange from "../../../components/datetime/DataRange";
import moment from "moment/moment";
import useCustomTranslation from "core/customTranslation";
import translations from "../translations";
import SearchSelect from "components/selects/SearchSelect";
import {useTranslation} from "react-i18next";

const FormFiltersModel = {
    uid: "",
    uuid: "",
    waste_type: "",
    download_type: "",
    group: "",
    zone: "",
    route: "",
    island: "",
    start: "",
    end: "",
};

const CollectionsListFilters = ({filters, params, onClickApplyFilters, downloadFilters, setItemsShown}) => {
    const {t: tC} = useCustomTranslation(translations);
    const {t: _tT} = useTranslation("tags");
    //const [dateRange, setDateRange] = useState([]);
    const [dateRangeSelected, setDateRangeSelected] = useState();
    // -
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [formFilters, setFormFilters] = useState({...FormFiltersModel});
    const defaultRange = useRef({
        start: new Date(),
        end: new Date(),
        startString: "",
        endString: "",
    });

    useState(() => {
        defaultRange.current.start = defaultRange.current.start.setDate(defaultRange.current.start.getDate() - 6);
        defaultRange.current.startString = moment(defaultRange.current.start).format("DD/MM/YYYY");
        defaultRange.current.endString = moment(defaultRange.current.end).format("DD/MM/YYYY");

        setDateRangeSelected(`${defaultRange.current.startString} - ${defaultRange.current.endString}`);
        //setDateRange([defaultRange.current.start, defaultRange.current.end]);
        filters.current.chosen.start = defaultRange.current.startString;
        filters.current.chosen.end = defaultRange.current.endString;
    }, []);

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        setFormFilters({...formFilters, [name]: value});
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    const handleClearFilters = () => {
        filters.current.chosen = {};
        setFormFilters({...FormFiltersModel});
        setItemsShown([]);
        clearDateRange();
    };

    const handleInputChange = (e) => {
        let {name, value} = e.target;
        value = value.trim().toUpperCase();
        setFormFilters({...formFilters, [name]: value});
        filters.current.chosen[name] = value;
        if (value) {
            filters.current.chosen[name] = value;
        } else {
            delete filters.current.chosen[name];
        }
    };

    const selectDataRange = (start, end) => {
        //setDateRange([start, end]);
        const formattedStart = start ? moment(start).format("DD/MM/YYYY") : "";
        const formattedEnd = end ? moment(end).format("DD/MM/YYYY") : "";
        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);
        filters.current.chosen.start = formattedStart;
        filters.current.chosen.end = formattedEnd;
    };

    const clearDateRange = () => {
        const formattedStart = moment(defaultRange.current.start).format("DD/MM/YYYY");
        const formattedEnd = moment(defaultRange.current.end).format("DD/MM/YYYY");
        setDateRangeSelected(`${formattedStart} - ${formattedEnd}`);
        filters.current.chosen.start = formattedStart;
        filters.current.chosen.end = formattedEnd;
    };

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{color: "black"}} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_tT("common.download")}
                        </label>
                        <DownloadTypesSelect multiple={false} value={formFilters.download_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {tC("filters.wasteType")}
                        </label>
                        <WasteTypesSelect multiple={false} value={formFilters.waste_type} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.groups")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.groups.map((g) => ({
                                    value: g.id,
                                    label: g.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.groups
                                    .filter((g) => g.id === formFilters.group)
                                    .map((g) => ({
                                        value: g.id,
                                        label: g.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    group: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.group = option.value;
                                } else {
                                    delete filters.current.chosen.group;
                                }
                            }}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.zones")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.zones.map((z) => ({
                                    value: z.id,
                                    label: z.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.zones
                                    .filter((z) => z.id === formFilters.zone)
                                    .map((z) => ({
                                        value: z.id,
                                        label: z.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    zone: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.zone = option.value;
                                } else {
                                    delete filters.current.chosen.zone;
                                }
                            }}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.routes")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.routes.map((r) => ({
                                    value: r.id,
                                    label: r.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.routes
                                    .filter((r) => r.id === formFilters.route)
                                    .map((r) => ({
                                        value: r.id,
                                        label: r.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    route: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.route = option.value;
                                } else {
                                    delete filters.current.chosen.route;
                                }
                            }}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "200px"}}>
                        <label style={labelStyle}>{tC("filters.islands")}</label>
                        <SearchSelect
                            options={[
                                {value: "", label: tC("filters.all")},
                                ...params.islands.map((i) => ({
                                    value: i.id,
                                    label: i.name,
                                })),
                            ]}
                            placeholder={tC("filters.all")}
                            isClearable={true}
                            value={
                                params.islands
                                    .filter((i) => i.id === formFilters.island)
                                    .map((i) => ({
                                        value: i.id,
                                        label: i.name,
                                    }))[0] || null
                            }
                            onChange={(option) => {
                                setFormFilters({
                                    ...formFilters,
                                    island: option ? option.value : "",
                                });
                                if (option && option.value) {
                                    filters.current.chosen.island = option.value;
                                } else {
                                    delete filters.current.chosen.island;
                                }
                            }}
                        />
                    </div>

                    <div className="col pt-3 mt-2">
                        <button
                            type="button"
                            onClick={onClickApplyFilters}
                            className="btn btn-outline-primary me-3"
                            title="Aplicar">
                            <FontAwesomeIcon icon="magnifying-glass" /> {tC("filters.search")}
                        </button>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-1 h5 text-center"></div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{tC("filters.containerUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uid"
                            value={formFilters.uid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "250px"}}>
                        <label style={labelStyle}>{tC("filters.deviceUUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            name="uuid"
                            value={formFilters.uuid}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col" style={{maxWidth: "260px"}}>
                        <label style={labelStyle}>{tC("filters.date")}</label>
                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{
                                        border: "1px solid #ced4da",
                                        minWidth: "100%",
                                    }}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label
                                        style={{
                                            width: "90%",
                                            textAlign: "center",
                                        }}>
                                        {" "}
                                        {dateRangeSelected}
                                    </label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange rangeData={selectDataRange} maxSpan={30} maxDate={new Date()} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>
                    {/* <div className="col pt-3 mt-2 text-end">
                        <button
                            type="button"
                            className="btn btn-primary"
                            title={tC("filters.downloadExcelTitle")}
                            onClick={downloadFilters}>
                            <FontAwesomeIcon icon="download" />{" "}
                            {tC("filters.downloadExcel")}
                        </button>
                    </div> */}
                </div>
            </div>
        </Collapse>
    );
};

export default CollectionsListFilters;
